import { createSelector } from 'reselect';

import { selectQuery, selectPayload } from '../location/selectors';

export const selectPageNumber = createSelector(
  selectQuery,
  (query) => parseInt(query.get('page'), 10) || 1
);

export const selectPageSize = createSelector(
  selectQuery,
  (query) => parseInt(query.get('pageSize'), 10) || 10
);

export const selectSearch = createSelector(selectQuery, (query) =>
  query.get('search', '')
);

export const selectTabName = createSelector(selectPayload, (params) =>
  params.get('tabName', null)
);

export const selectCursor = createSelector(selectQuery, (query) =>
  query.get('cursor', null)
);

export const selectCourseInfoTabName = createSelector(
  selectTabName,
  (tabName) => {
    switch (tabName) {
      case 'property':
      case 'marketplace':
      case 'copy':
        return tabName;
      default:
        return 'property';
    }
  }
);
